import styled from 'styled-components';

export const AlertDangerStyle = styled.div`
  position: relative;
  padding: 1rem 3.5rem;
  margin: 1rem 0;
  border: 1px solid ${({ theme }) => theme.UI_COLORS.error};
  border-radius: 0.25rem;
  background-color: ${({ theme }) => theme.UI_COLORS.light};
  color: ${({ theme }) => theme.UI_COLORS.error};
  font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyTextSmall.fontSize};
  cursor: default;

  button {
    cursor: pointer;
    background: transparent;
    color: ${({ theme }) => theme.UI_COLORS.error};
    border: none;
    outline: none;
    position: absolute;
    right: 0;
    top: 1.2rem;
    padding: 0 1rem;
  }
  a {
    color: ${({ theme }) => theme.UI_COLORS.info};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  .alert-icon {
    margin-right: 0.2rem;
  }
`;
